// src/components/OutletHost.tsx
import { useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { Fragment, jsx } from "react/jsx-runtime";
var OutletContent = ({ entry }) => {
  return /* @__PURE__ */ jsx(Fragment, { children: entry.render(...entry.args) });
};
var OutletHost = ({ store }) => {
  const { entries } = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
  return /* @__PURE__ */ jsx(Fragment, { children: Array.from(entries.values(), (entry) => createPortal(/* @__PURE__ */ jsx(OutletContent, { entry }), entry.el, entry.id)) });
};
export {
  OutletHost
};
//# sourceMappingURL=OutletHost.js.map